import { Member } from '@/models/member';
import { makeRequest } from './api-request';

const updateMember = async (memberUuid: string, data: object) => {
  const body = JSON.stringify(data);
  await makeRequest('PATCH', `/members/${memberUuid}`, { body });
};

const groupByTag = (members: Array<Member>) => {
  const groupsMap: { [key: string]: { name: string; members: any[] } } = {};

  members.forEach(member => {
    if (!member.tags) return;
    member.tags.forEach(tag => {
      if (!groupsMap[tag]) {
        groupsMap[tag] = { name: tag, members: [] };
      }
      groupsMap[tag].members.push(member);
    });
  });

  return Object.values(groupsMap).sort((a, b) => a.name.localeCompare(b.name));
};

export { updateMember, groupByTag };
